export default "__VITE_ASSET__BYcBff7m__"